/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notes_Mark_As_Done_LabelInputs */



/**
* | output |
* | --- |
* | "Mark as done" |
*
* @param {Notes_Mark_As_Done_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const notes_mark_as_done_label = /** @type {((inputs?: Notes_Mark_As_Done_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notes_Mark_As_Done_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Marquer comme termine")
	if (locale === "de") return /** @type {LocalizedString} */ ("Als erledigt markieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Segna come fatto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Отметить как выполненное")
	if (locale === "es") return /** @type {LocalizedString} */ ("Marcar como hecho")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("标记为已完成")
	if (locale === "ja") return /** @type {LocalizedString} */ ("完了としてマーク")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पूर्ण हुआ चिह्नित करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Marcar como concluído")
	return /** @type {LocalizedString} */ ("Mark as done")
});